import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { IPromptProfile } from '../../types/prompt-profile';
import { BullhornEntityType } from '../../types/bullhorn/bullhorn-entity-type';
import { IClientConfig } from '../../types/client-config';
import { PromptProfileFieldLabel } from '../../types/prompt-profile-property';

@Component({
    selector: 'app-prompt-paragraph',
    templateUrl: './prompt-paragraph.component.html',
    styleUrls: ['./prompt-paragraph.component.scss'],
    standalone: false
})
export class PromptParagraphComponent implements OnInit {
  @Input() promptProfile!: IPromptProfile | any;
  @Input() entityType!: BullhornEntityType;
  @Input() clientConfig!: IClientConfig;
  protected editStates: any;

  templateConfig: { before: string; key: PromptProfileFieldLabel; after?: string }[] = [
    { before: 'You are a ', key: 'role', after: '. ' },
    { before: 'In a ', key: 'tone', after: ' style, ' },
    { before: 'Using the information on this record, ', key: 'action', after: '. ' },
    { before: 'The length should be ', key: 'resultLength', after: '. ' },
    { before: 'The format should be ', key: 'format', after: '. ' },
    { before: 'The result should be written in ', key: 'outputLanguage', after: '. ' },
    {
      before: 'The result should have a difficulty level of: ',
      key: 'explanationDifficulty',
      after: '. ',
    },
  ];

  constructor(public dialog: MatDialog) {}

  ngOnInit(): void {
    this.editStates = { ...this.promptProfile } as Object;
    Object.keys(this.editStates).forEach((k) => {
      this.editStates[k] = false;
    });
  }
}
